import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const retrieveUnitsPerModelEndpoint = (
  model_id: string,
  params: {},
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/project-model/${model_id}/model-units-list`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        params: params,
      }),
    controller,
  };
};

export const markUnitsPerModelAvailableInBulkEndpoint = (
  model_id: string,
  payload: {},
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/project-model/${model_id}/model-units-list/mark-as-available`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const retrieveModelUnitInCSVEndpoint = (
  model_id: string,
  payload: {},
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/pre-sales/v1/admin/project-model/${model_id}/model-units-list/generate-csv`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
        responseType: 'blob',
      }),
    controller,
  };
};

export const editModelUnitInBulkEndpoint = (
  model_id: string,
  form: any,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/project-model/${model_id}/model-units-in-bulk`,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
